import React, { useEffect } from "react";
import MultiplePolicy from "./MultiplePolicy";
import { ClientPolicies } from "../../../../model/clientPolicies";
import { useSelector } from "react-redux";
import { RootState } from "../../../../reducers";
import { history } from "../../../../configureStore";
import { useActions } from "../../../../actions";
import * as ClientActions from "../../../../actions/client";
import * as Actions from "../../../../actions/account";
import { getPolicyName, isPolicyIssued } from "../../helper";
import { makeStyles } from "@material-ui/core/styles";
import { GlobalLoader } from "../../../../App";



const useStyles = makeStyles({
    root: {
        height: "100%",
        paddingTop: 20,
        paddingLeft: 15,
        paddingRight: 15,
    },
    progress: {
        margin: 20,
    },
});

const PoliciesSelectBox = ({ clientId, clientPolicy,  redirectPath }: { clientPolicy?: any, clientId?: number, redirectPath:string }) => {
    const [clientPolicyList, setClientPolicyList] = React.useState<object[]>([]);

    let { user } = useSelector((state: RootState) => state.auth);
    let profileData = useSelector((state: RootState) => state.profile)
    if(user.accessType == "client"){
        user = profileData
    }
    const { setProgress } = React.useContext(GlobalLoader);
    if (!clientPolicy) {
        clientPolicy = (user && user.client && user.client.clientPolicies && user.client.clientPolicies[0]) as ClientPolicies;
    }
    if (!clientId) {
        clientId = user && user.client && user.client.id;
    }

    const classes = useStyles();
    // const [progress, setProgress] = React.useState()
    const accountActions = useActions(Actions);
    const { getClientPolicies, updateClientPolicy } = useActions(ClientActions);
    const updatePolicyId = async (clientPolicyId: any, selectedPolicy: any) => {
        try {
            if(clientPolicyId){
                setProgress(true);
                await updateClientPolicy({ id: clientPolicyId }, true);
                await accountActions.getProfileDetails();
                if (selectedPolicy.policyIssued) {
                    history.push(redirectPath);
                } else {
                    history.push("/dashboard");
                }
                setProgress(false);
                return;
            }
        } catch (error) {
            console.error("Error ", error);
        }
    };

    useEffect(() => {
        const getClientAllPolicies = async () => {
            try {
                const allPolicies = await getClientPolicies(clientId);
                // await updatePolicyId(clientPolicy && clientPolicy.id);
                const clientPolicyArr = allPolicies && allPolicies.length > 0 && allPolicies.map((item) => {
                    const name = item.policyNumber ? item.policyNumber : item.id;
                    return {
                        key: item.id,
                        value: item.id,
                        name: getPolicyName(item as any),
                        policyIssued: isPolicyIssued(item as any),
                    };
                }) || [];
                if (Object.keys(clientPolicyArr).length > 0) {
                    setClientPolicyList(clientPolicyArr);
                } else if (clientPolicy && clientPolicy.id) {
                    const policyArray = [{ key: clientPolicy.id, value: clientPolicy.id, name: clientPolicy.id }];
                    setClientPolicyList(policyArray);
                } else {
                    const emptyArray = [{ key: "", value: "", name: "No Policy Found" }];
                    setClientPolicyList(emptyArray);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        getClientAllPolicies();
    }, [clientId]);


    return (
            <>
                <MultiplePolicy
                        clientPolicyId={clientPolicy && clientPolicy.id}
                        clientPolicyList={clientPolicyList}
                        updatePolicyId={updatePolicyId}
                />
            </>
    );
};

export default PoliciesSelectBox;